import { Button, type ButtonProps, useDisclosure } from "@chakra-ui/react";
import { ModalInvoices } from "@src/components/widgets/Modals/ModalInvoices";
import { currency, percent } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import React from "react";
import { ExpenseBudgetItemModel, OurWorkBudgetItemModel } from "../models";
import { useStore } from "../Store";

interface InvoicedButtonProps {
  item: OurWorkBudgetItemModel | ExpenseBudgetItemModel;
}

const InvoicedButton = ({
  item,
  ...props
}: InvoicedButtonProps & ButtonProps) => {
  const store = useStore();
  const modalInvoices = useDisclosure();

  return (
    <React.Fragment>
      <Button
        fontSize="sm"
        colorScheme="blue"
        onClick={modalInvoices.onOpen}
        variant="link"
        {...props}
      >
        {currency.formatByWorkspace(item.stats.credit)}
        {` (${percent.format(item.stats.invoiced_percent)})`}
      </Button>
      <ModalInvoices
        {...modalInvoices}
        ourWorkBudgetItemId={
          item instanceof OurWorkBudgetItemModel ? item.id : undefined
        }
        expenseBudgetIdemId={
          item instanceof ExpenseBudgetItemModel ? item.id : undefined
        }
        onTransfer={store.refetchProject}
      />
    </React.Fragment>
  );
};

export default observer(InvoicedButton);
